import http from 'shared/utils/http';

export const getWaveSetups = () => {
  return http.get('/integrated-shipping/wave-setup');
};

export const createWaveSetup = (data) => {
  return http.post('/integrated-shipping/wave-setup', data);
};
